import { render, staticRenderFns } from "./task_icon.vue?vue&type=template&id=2a2d83af"
import script from "./task_icon.vue?vue&type=script&lang=js"
export * from "./task_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports